// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bj-tag-color-20211104 .tag-color {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n}\n.bj-tag-color-20211104 .el-radio__label {\n  padding-right: 20px;\n  padding-left: 6px;\n}\n.bj-tag-color-20211104 .el-radio {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
